import React from 'react';

// import components
import StandardContent from 'components/partials/standard-content';
import ContentBlocksBuilder from 'helpers/builders/content-blocks-builder';
import Accordion from 'components/partials/accordion';

// import types
import { ContentBlocks } from 'types/content-blocks';

// import helpers
import { getAccordionFaq } from 'helpers/get-accordion-faq';
import LinkListCardsCollectionBuilder from 'helpers/builders/link-list-cards-collection-builder';

type HelpCenterTopicProps = {
    topic: Queries.HelpCenterTopicBlockFragment;
}

const HelpCenterTopic: React.FC<HelpCenterTopicProps> = ({ topic }) => {

    let faqs = topic.faqs as Queries.FaqBlockFragment[] || [];

    let accordionPropsData = getAccordionFaq(faqs);

    const linkListCardArray: Queries.LinkListCardBlockFragment[] = topic.linkListCard ? [topic.linkListCard] : [];

    let linkListCardsCollectionData: Queries.LinkListCardsCollectionBlockFragment = {
        __typename: "DatoCmsLinkListCardsCollection",
        id: `link-list-cards-collection-for-topic-${topic.id}`,
        heading: "",
        linkListCards: linkListCardArray
    };

    return (
        <>
            <StandardContent>
                <h2>{topic.title}</h2>
            </StandardContent>
            <ContentBlocksBuilder contentBlocks={topic.standardContent?.content as ContentBlocks} />
            {accordionPropsData && <Accordion {...accordionPropsData} />}
            <LinkListCardsCollectionBuilder linkListCardsCollectionData={linkListCardsCollectionData} services={topic.services as Queries.ServiceFieldsFragment[] || []} />
        </>
    );
};

export default HelpCenterTopic;